<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiDraw } from "@mdi/js";
export default {
  name: "MdiDraw",
  data() {
    return {
      svgPath: mdiDraw,
    };
  },
};
</script>
